import Pusher from 'pusher-js';
import storageManager from './LocalStorageManager'



export default {
  async updateData(data) {
    data.id = storageManager.getPlayerId()
    const room = storageManager.getRoom();

    console.log(data)

    let response = await fetch('/api/websocket?room=' + room, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(data)
    });
    let result = await response.json();
    console.log(result)
  },
  async rollDice(text) {
    const data = { playerName: storageManager.getName(), text }
    const room = storageManager.getRoom();

    console.log(room)

    let response = await fetch('/api/rolldice?room=' + room, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=utf-8'
      },
      body: JSON.stringify(data)
    });
    let result = await response.json();
    console.log(result)
  },
  subscribeChannel(room, event, callback) {
    const theRoom = storageManager.getRoom();

    console.log('testetetete' + theRoom)

    const pusher = new Pusher('2cf8828e6d09c873d888', {
      cluster: 'us2',
      encrypted: true
    });

    const channel = pusher.subscribe(theRoom);
    channel.bind(event, data => callback(data));
  },
  disconnect() {
    const theRoom = storageManager.getRoom();

    console.log('testetetete' + theRoom)

    const pusher = new Pusher('2cf8828e6d09c873d888', {
      cluster: 'us2',
      encrypted: true
    });

    const channel = pusher.subscribe(theRoom);
    channel.unbind_all();
    
    pusher.disconnect();
  }
}